// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3768":"6d201fbb","4168":"f6a3c272","4301":"3ed4bc1b","4519":"8b133ce7","7593":"f9578121","9228":"e56d55b5","9573":"822a47ab"}[chunkId] + ".chunk.css";
};